var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20248 7.20297C1.15386 7.072 1.15386 6.92793 1.20248 6.79697C1.67597 5.64888 2.47969 4.66724 3.51176 3.97649C4.54383 3.28574 5.75775 2.91699 6.99964 2.91699C8.24153 2.91699 9.45546 3.28574 10.4875 3.97649C11.5196 4.66724 12.3233 5.64888 12.7968 6.79697C12.8454 6.92793 12.8454 7.072 12.7968 7.20297C12.3233 8.35105 11.5196 9.33269 10.4875 10.0234C9.45546 10.7142 8.24153 11.0829 6.99964 11.0829C5.75775 11.0829 4.54383 10.7142 3.51176 10.0234C2.47969 9.33269 1.67597 8.35105 1.20248 7.20297Z",
    stroke: "currentColor",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.75C7.9665 8.75 8.75 7.9665 8.75 7C8.75 6.0335 7.9665 5.25 7 5.25C6.0335 5.25 5.25 6.0335 5.25 7C5.25 7.9665 6.0335 8.75 7 8.75Z",
    stroke: "currentColor",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.57c37060e1e7deee69cad2db6a8bb941.svg";
export { ForwardRef as ReactComponent };